import React, { useContext, useEffect, useState , useRef } from "react";
import { IdentityPhotoHeaderDescription } from "./styles";
import { default as ClientRegistrationTypes } from "../../../store/ClientRegistration/types";
import { useDropzone } from "react-dropzone";
import { ClientRegistrationContext } from "../../../store";
import InputFile from "../../../components/InputFile";
import { clientRegistrationSteps } from "../../../helpers/enum";
import { SecondaryLargeButton } from "../../../components/Buttons/styles";
import FormTemplate from "../../../components/FormTemplate";
import { Form, FormFooter } from "../../../components/FormTemplate/styles";
import Loader from "../../../components/Loader";
import ModalInfo from "../../../components/ModalInfo";
import { verifyPhotoByOcr } from "../../../services/ocr";
import { toBase64 } from "../../../helpers/base64";
import colors from "../../../assets/styles/colors";
import { BsExclamation } from "react-icons/bs";
import { useLocation } from 'react-router-dom';
import { getCoreImagenesCedula, getImagenesCedula } from '../../../services/clients';
import InputFileBackGroundImage from "../../../components/InputFileBackGroundImage";

const IdentityPhotoPage = ({ setActiveStep, setLastStep }) => {
  const { clientRegistration, setClientRegistration } = useContext(
    ClientRegistrationContext
  );
  const [canAddFile, setCanAddFile] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [showModalInfo, setShowModalInfo] = useState(false);
  const location = useLocation();


  async function onSubmit(e) {
    try {
      setIsLoading(true);
      e.preventDefault();

      let registration = {};

      //let firstPhoto = await toBase64(clientRegistration.identityPhoto[0]);
      //let secondPhoto = await toBase64(clientRegistration.identityPhoto[1]);

      let firstPhoto = clientRegistration.identityPhoto[0];
      let secondPhoto = clientRegistration.identityPhoto[1];
      //firstPhoto = firstPhoto.replace("data:image/png;base64,", "");
      //secondPhoto = secondPhoto.replace("data:image/png;base64,", "");
      //firstPhoto = firstPhoto.replace("data:image/jpeg;base64,", "");
      //secondPhoto = secondPhoto.replace("data:image/jpeg;base64,", "");

      let firstPhotoData = {
        imageBase64: firstPhoto,
      };

      let secondPhotoData = {
        imageBase64: secondPhoto,
      };


      //cinco minutos tiempo maximo respuesta
      /*let timeLimit = 300000;
      let failureValue = null;
      firstPhotoData = await fulfillWithTimeLimit(timeLimit, verifyPhotoByOcr(firstPhotoData), failureValue);
      secondPhotoData = await fulfillWithTimeLimit(timeLimit, verifyPhotoByOcr(secondPhotoData), failureValue);*/
      let data = {};
      /*if (firstPhotoData != null){
        data = verifyIdentities(firstPhotoData.data.data, registration);
      }
      if (secondPhotoData != null){
        data = verifyIdentities(secondPhotoData.data.data, data);
      } */

      setClientRegistration({
        type: ClientRegistrationTypes.SET_REGISTRATION_DATA,
        registration: data,
      });

      setIsLoading(false);

      setLastStep(clientRegistrationSteps.IDENTITY_FOTO);
      setActiveStep(clientRegistrationSteps.REGISTRATION);
    } catch (error) {
      console.log(error);
      console.log(error.response);
    }
  }

  /*async function devImagenes(idcredito) {
    setIsLoading(true);
    const imagenesvalidacion = await getImagenesCedula(idcredito);
    const arr = [];
    if (imagenesvalidacion !== null) {
      if (imagenesvalidacion.data.reverso !== null) {
        
        const byteCharacters1 = atob(imagenesvalidacion.data.reverso);
        const byteNumbers1 = new Array(byteCharacters1.length);
        for (let i = 0; i < byteCharacters1.length; i++) {
          byteNumbers1[i] = byteCharacters1.charCodeAt(i);
        }
        const byteArray1 = new Uint8Array(byteNumbers1);
        //arr[0] = new Blob([byteArray1], { type: 'image/jpeg' });
        const the_file1 = new Blob([byteArray1], { type: 'image/jpeg' });
        arr[0] = new File([the_file1], 'reverso.jpeg', { type: 'image/jpeg' });
        //arr[0] = (new File([new Blob([imagenesvalidacion.data.reverso], { type: 'image/jpg' })], 'cedulareverso.jpg', { type: 'image/jpg' }));
        onDrop(arr);
      }

      if (imagenesvalidacion.data.adverso !== null) {
        const byteCharacters2 = atob(imagenesvalidacion.data.adverso);
        const byteNumbers2 = new Array(byteCharacters2.length);
        for (let i = 0; i < byteCharacters2.length; i++) {
          byteNumbers2[i] = byteCharacters2.charCodeAt(i);
        }
        const byteArray2 = new Uint8Array(byteNumbers2);
        //arr[0] = new Blob([byteArray2], { type: 'image/jpeg' });
        const the_file2 = new Blob([byteArray2], { type: 'image/jpeg' });
        arr[0] = new File([the_file2], 'adverso.jpeg', { type: 'image/jpeg' });
        //arr[0] = (new File([new Blob([imagenesvalidacion.data.adverso], { type: 'image/jpg' })], 'cedulaadverso.jpg', { type: 'image/jpg' }));
        onDrop(arr);
      }
      setIsLoading(false);
    }
    setIsLoading(false);
  }*/

  async function devImagenes(identificacion) {
    setIsLoading(true);
    const imagenesvalidacion = await getCoreImagenesCedula(identificacion);
    const arr = [];
    if(imagenesvalidacion.data !== null){
      if(imagenesvalidacion.data.file1 !== null){
        const byteCharacters1 = atob(imagenesvalidacion.data.file1);
        const byteNumbers1 = new Array(byteCharacters1.length);
        for (let i = 0; i < byteCharacters1.length; i++) {
          byteNumbers1[i] = byteCharacters1.charCodeAt(i);
        }
        const byteArray1 = new Uint8Array(byteNumbers1);
        //arr[0] = new Blob([byteArray1], { type: 'image/jpeg' });
        const the_file1 = new Blob([byteArray1], { type: 'image/jpeg' });
        arr[0] = new File([the_file1], 'reverso.jpeg', { type: 'image/jpeg' });
        //arr[0] = (new File([new Blob([imagenesvalidacion.data.reverso], { type: 'image/jpg' })], 'cedulareverso.jpg', { type: 'image/jpg' }));
        onDrop(arr);
      }
      if(imagenesvalidacion.data.file2 !== null){
        const byteCharacters1 = atob(imagenesvalidacion.data.file2);
        const byteNumbers1 = new Array(byteCharacters1.length);
        for (let i = 0; i < byteCharacters1.length; i++) {
          byteNumbers1[i] = byteCharacters1.charCodeAt(i);
        }
        const byteArray1 = new Uint8Array(byteNumbers1);
        //arr[0] = new Blob([byteArray1], { type: 'image/jpeg' });
        const the_file1 = new Blob([byteArray1], { type: 'image/jpeg' });
        arr[0] = new File([the_file1], 'reverso.jpeg', { type: 'image/jpeg' });
        //arr[0] = (new File([new Blob([imagenesvalidacion.data.reverso], { type: 'image/jpg' })], 'cedulareverso.jpg', { type: 'image/jpg' }));
        onDrop(arr);
      }
    }
    setIsLoading(false);
  }


  async function fulfillWithTimeLimit(timeLimit, task, failureValue) {
    let timeout;
    const timeoutPromise = new Promise((resolve, reject) => {
      timeout = setTimeout(() => {
        resolve(failureValue);
      }, timeLimit);
    });
    let response;
    try {
      response = await Promise.race([task, timeoutPromise]);
    } catch (error) {
      console.log(error);
      console.log(error.response);
      response = failureValue;
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    return response;
  }

  function verifyIdentities(data, obj) {
    if (data.entities.nombres && !obj.primerNombre) {
      let names = data.entities.nombres.split(" ");
      obj.primerNombre = names[0];

      if (names[1]) {
        obj.segundoNombre = names[0];
      } else {
        obj.segundoNombre = "";
      }
    }

    if (data.entities.apellidos && !obj.primerApellido) {
      let middleName = data.entities.apellidos.split(" ");
      obj.primerApellido = middleName[0];

      if (middleName[1]) {
        obj.segundoApellido = middleName[1];
      } else {
        obj.segundoApellido = "";
      }
    }

    if (data.entities.fecha_de_nacimiento && !obj.fechaNacimiento) {
      obj.fechaNacimiento = data.entities.fecha_de_nacimiento;
    }

    if (data.entities.fecha_de_expedicion && !obj.fechaExpedicionDoc) {
      obj.fechaExpedicionDoc = data.entities.fecha_de_expedicion;
    }

    if (data.entities.lugar_de_expedicion && !obj.expedicion) {
      obj.expedicion = "";
    }

    if (data.entities.nuip && !obj.identificacion) {
      obj.identificacion = data.entities.nuip;
    }

    if (data.entities.nuip && obj.identificacion) {
      obj.tipoIdentificacion =
        data.entities.nuip.indexOf(".") > -1 ? "cc" : "ce";
    } else {
      obj.tipoIdentificacion = "cc";
    }

    if (data.entities.genero && !obj.genero) {
      obj.genero = data.entities.genero;
    } else {
      obj.genero = "m";
    }

    return obj;
  }

  function onDrop(file) {
    if (file[0].size / Math.pow(1024, 2) > 10) {
      setShowModalInfo(true);
    } else {
      if (clientRegistration.identityPhoto.length <= 1) {
        setCanAddFile(false);
        setClientRegistration({
          type: ClientRegistrationTypes.ADD_IDENTITY_PHOTO_FILE,
          file,
        });
      }
    }
  }

  function removeFile(key) {
    const file = clientRegistration.identityPhoto.filter(
      (value, index) => index !== key
    );

    setClientRegistration({
      type: ClientRegistrationTypes.REMOVE_IDENTITY_PHOTO_FILE,
      file,
    });
  }



  useEffect(() => {
    if (clientRegistration.identityPhoto.length < 2) {
      setCanAddFile(true);
      
      if (clientRegistration.identityPhoto.length === 0) {
        let identificacion = clientRegistration?.cliente?.identificacion 
          ? clientRegistration.cliente.identificacion 
          : clientRegistration?.simulacion?.cliente?.identificacion;
  
        if (identificacion) {
          devImagenes(identificacion);
        }
      }
    } else {
      setTimeout(() => {
        setCanAddFile(false);
      }, 2000);
    }
  }, [clientRegistration.identityPhoto]);  



  return (
    <FormTemplate
      idForm="identity-photo-step-page"
      activeStep="1/2"
      stepLabel="Foto o imagen de la cédula"
    >
      <Form onSubmit={onSubmit} id="form">
        <IdentityPhotoHeaderDescription>
          Asegúrate que las imágenes sean claras y de buena resolución para una
          adecuada captura de datos.
          Ten en cuenta que debes adjuntar cada foto por separado del frente y
          posterior del documento de identidad del cliente.
        </IdentityPhotoHeaderDescription>

        {/*<InputFile
          getInputProps={getInputProps}
          getRootProps={getRootProps}
          canAddFile={canAddFile}
          //selectedFile={clientRegistration.identityPhoto}
          files={clientRegistration.identityPhoto}
          removeFile={removeFile}
          description="Elige dos archivos PNG, JPEG o JPG, o arrasta aqui."
        />*/}
        <InputFileBackGroundImage
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        canAddFile={canAddFile}
        //selectedFile={clientRegistration.identityPhoto}
        files={clientRegistration.identityPhoto}
        removeFile={removeFile}
        description="Elige dos archivos PNG, JPEG o JPG, o arrasta aqui."
        />
        
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit" disabled={canAddFile} id="submit">
            Siguiente{" "}
          </SecondaryLargeButton>
        </FormFooter>
      </Form>
      {isLoading && <Loader />}
      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title="Has excedido el tamaño de archivo permitido"
        description="El tamaño máximo de envío es de 10 MB"
        backgroundIcon={colors.bgDanger}
        bodyIcon={
          <BsExclamation size={32} color={colors.white} id="exclamation-icon" />
        }
      />
    </FormTemplate>
  );
};

export default IdentityPhotoPage;
